import { checkConsent } from './check-consent';
import { onConsentChange } from './on-consent-change';
import type { CheckConsentOptions, ConsentCategory } from './types';

const hasConsent = (activeGroups: string, category: ConsentCategory) =>
  activeGroups.split(',').includes(category);

export function initializeWithConsent(
  category: ConsentCategory,
  initializer: () => void,
  options?: CheckConsentOptions,
): () => void {
  let cancelled = false;
  let initialized = false;

  const initializeOnce = () => {
    if (cancelled || initialized) return;

    initialized = true;
    unsubscribe();
    initializer();
  };

  const unsubscribe = onConsentChange((activeGroups) => {
    if (hasConsent(activeGroups, category)) {
      initializeOnce();
    }
  });

  checkConsent(category, options).then((granted) => {
    if (granted) {
      initializeOnce();
    }
  });

  return () => {
    cancelled = true;
    unsubscribe();
  };
}
